/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import t from 'tcomb-validation';

import ConnectionStatus from 'config/constants/network/ConnectionStatus';

const ConnectionStatusEnum = t.enums(ConnectionStatus);

export default ConnectionStatusEnum;